import MyModal from "./MyModal"
const MyDialog = {
  show({
    title = "",
    msg = "",
    backdrop = "",
    onOK = null,
    onCancel = null,
    showFooter = true,
    modalClassName = "",
  } = {}) {
    MyModal.showMyDialog(
      {
        onOK,
        onCancel,
      },
      {
        title: title,
        component: msg,
        modalCentered: true,
        size: "md",
        showFooter: showFooter,
        backdrop: backdrop || "static",
        modalClassName: modalClassName,
      }
    )
  },
  // show({ title = "", msg = "", onClickOK = (cModal: any) => {} } = {}) {
  //   MyModal.showMyDialog({
  //     title: title,
  //     component: msg,
  //     modalCentered: true,
  //     size: "md",
  //     showFooter: true,
  //     showFooterOK: true,
  //     backdrop: "static",
  //     onClickOK: cModal => {
  //       if (onClickOK) {
  //         onClickOK(cModal)
  //       }
  //       if (cModal.hide) {
  //         cModal.hide()
  //       }
  //     },
  //   })
  // },
  // showConfirm({ title = "", msg = "", onClickOK = (cModal: any) => {} } = {}) {
  //   MyModal.showMyDialog({
  //     title: title,
  //     component: msg,
  //     modalCentered: true,
  //     size: "md",
  //     showFooter: true,
  //     showFooterOK: true,
  //     showFooterClose: true,
  //     backdrop: "static",
  //     onClickOK: cModal => {
  //       if (onClickOK) {
  //         onClickOK(cModal)
  //       }
  //       if (cModal.hide) {
  //         cModal.hide()
  //       }
  //     },
  //   })
  // },
}

export default MyDialog
